import store from '@apply/adminStore';
import { LoanActionType } from '../LoanConstants';
import { executeLoanAction } from './executeLoanAction';
import { getDrawBudgetURL } from '../LoanFunctions';
import { Location } from 'react-router';

export const OnOpenLoanDetail = (e, location: Location) => {
    const { dispatch } = store;
    if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
        return;
    }

    if (e.column.caption === 'Funded' && e.data.drawBudgetId) {
        window.location.href = getDrawBudgetURL(e.data.drawBudgetId, location); // eslint-disable-line

        return;
    }
    var model = {
        id: LoanActionType.Modify,
        loanId: e.data.id,
        loanTypeId: e.data.loanTypeId,
    };
    executeLoanAction(model, dispatch, location, false);
};
